import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import generateGuid from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";

const TextInput = (props) => {
	const hasInputMask = !!props.inputmask;
	const hasValue = !!props.value || hasInputMask;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const value = props.value ? props.value : "";
	const sizeClassName = props.size ? `l-grid__col:${props.size}/12` : "l-grid__col:12/12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = hasValidationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const maxLength = props.maxLength ? props.maxLength : "";
	const disabled = props.disabled || props.readOnly;
	const id = props.id ? props.id : generateGuid();
	const style = props.style;
	const surroundingStyle = props.surroundingStyle;

	const revertable = props.originalValue !== undefined ? props.originalValue !== props.value : false;

	const inputClassName = classnames({
		"c-input__field": true
	});

	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"l-form__item": true,
		"c-input": true,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": disabled
	});

	function handleChange(event) {
		if (hasInputMask && event.target.value.indexOf(props.inputmask) === -1)
			event.target.value = props.inputmask + event.target.value;

		props.onChange(event);
	}

	return (
		<div className={sizeClassName}>
			<div className={containerClassName} style={surroundingStyle}>
				{props.label ?
					<label
						className={labelClassName}
						htmlFor={id}>
						{label}
					</label> : null}
				<input
					id={id}
					style={style}
					value={value}
					disabled={disabled}
					onChange={handleChange}
					className={inputClassName}
					maxLength={maxLength}
					name={props.name} />
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue} />}
			</div>
			{validation}
		</div>
	);
};

TextInput.defaultProps = {
	validationMessageType: "ERROR"
};

TextInput.propTypes = {
	name: PropTypes.string.isRequired,
	id: PropTypes.string,
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	originalValue: PropTypes.string,
	onChange: PropTypes.func,
	maxLength: PropTypes.number,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	style: PropTypes.object,
	surroundingStyle: PropTypes.object,
	inputmask: PropTypes.string
};

export default TextInput;
